<button class="material-icons" mat-dialog-close>close</button>
<div class="top-image-pdf ckeditor-front" [innerHTML]="yt | safe: 'html'"></div>